import { render, staticRenderFns } from "./Productsn.vue?vue&type=template&id=6215312d&scoped=true"
import script from "./Productsn.vue?vue&type=script&lang=js"
export * from "./Productsn.vue?vue&type=script&lang=js"
import style0 from "./Productsn.vue?vue&type=style&index=0&id=6215312d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6215312d",
  null
  
)

export default component.exports